import React from 'react';

interface NumberCardProps {
  icon: string;
  number?: number;
  text: string;
}

const NumberCard: React.FC<NumberCardProps> = ({ icon, number, text }) => {
  return (
    <div className="shadow-[0px_3px_0px_#3ebec8] rounded-[25px] bg-white box-border overflow-hidden shrink-0 flex flex-col py-4 px-6 text-darkgray border-2 border-solid border-primary w-full">
      <div className="flex flex-col items-center justify-start space-y-4">
        <div className="flex flex-row items-center justify-center">
          <img
            className="overflow-hidden shrink-0 w-10 h-10 text-primary"
            alt="Icon"
            src={icon}
          />
        </div>
        <div className="flex flex-col items-center justify-start text-secondary">
          <h1 className="font-bold scroll-m-20 text-5xl font-extrabold tracking-tight lg:text-6xl">
            {number}
          </h1>
          <h2 className="scroll-m-20 border-b pb-2 text-lg font-semibold tracking-tight first:mt-0 text-primary">
            {text}
          </h2>
        </div>
      </div>
    </div>
  );
};

export default NumberCard;
